export const MESSAGES = {
  DELETE_STATUS: "MESSAGES.DELETE_STATUS",
  PROPOSAL_STATUS: "MESSAGES.PROPOSAL_STATUS",
  UPLOAD_STATUS: "MESSAGES.UPLOAD_STATUS",
  DOWNLOAD_STATUS: "MESSAGES.DOWNLOAD_STATUS",
  FILE_STATUS: "MESSAGES.FILE_STATUS",
  USER_STATUS: "MESSAGES.USER_STATUS"
};

export default MESSAGES;
